import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { reportError } from "../shared/api/errors.ts";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError: reportError }),
    mutationCache: new MutationCache({ onError: reportError }),
    defaultOptions: {
      queries: { staleTime: 30_000 },
    },
  });
}
